<div class="heading-wrapper">
  <p class="heading">
    {{ 'myAccount.editPreferences' | cxTranslate }}
  </p>
</div>
@if (managedPreferences$ | async; as data) {
<div class="notification-wrapper">
  @for (enum of data.enums; track enum) { @if (myaccountAccountInfo$ | async; as myaccount) {
  <mat-checkbox
    [checked]="compareValue(enum, this.preferencesCodes)"
    disableRipple
    class="notification-checkbox"
    [color]="'primary'"
    (change)="onChangeEventFunc(enum.code, $event)"
  >
    {{ enum.name }}
  </mat-checkbox>
  } }
</div>
} @if (!this.isMobile) {
<div class="notification-button-wrapper">
  <button
    class="btn secondary-btn"
    [routerLink]="
      {
        cxRoute: 'myAccount'
      } | cxUrl
    "
  >
    {{ 'common.cancel' | cxTranslate }}
  </button>
  <button
    class="btn primary-btn"
    [class.disabled]="isBtnDisabled"
    [disabled]="isBtnDisabled"
    (click)="onSubmit($event)"
  >
    {{ 'common.save' | cxTranslate }}
  </button>
</div>
} @if (this.isMobile) {
<div class="notification-button-wrapper">
  <button
    class="btn primary-btn"
    [class.disabled]="isBtnDisabled"
    [disabled]="isBtnDisabled"
    (click)="onSubmit($event)"
  >
    {{ 'common.save' | cxTranslate }}
  </button>
  <button
    class="btn secondary-btn"
    [routerLink]="
      {
        cxRoute: 'myAccount'
      } | cxUrl
    "
  >
    {{ 'common.cancel' | cxTranslate }}
  </button>
</div>
}
